(() => {
  const videos = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const autoAllowed = () => !motion.matches && !navigator.connection?.saveData;
  const load = (video) => {
    if (video.getAttribute('src')) return;
    const small = navigator.connection?.saveData || video.clientWidth * devicePixelRatio <= 480;
    video.src = small ? video.dataset.lowSrc : video.dataset.src;
    video.load();
  };
  const play = (video) => {
    load(video);
    video.play().catch(() => {});
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = videos.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= .15;
      if (!state.visible || document.hidden) state.video.pause();
      else if (autoAllowed() && !state.userPaused) play(state.video);
    });
  }, {threshold: [0, .15]}) : null;
  const init = root => root.querySelectorAll('[data-luciano-video]').forEach(shell => {
    if (videos.has(shell)) return;
    const video = shell.querySelector('video');
    const button = shell.querySelector('button');
    const state = {video, visible:false, userPaused:false};
    videos.set(shell, state);
    video.muted = true;
    button.hidden = false;
    button.addEventListener('click', () => {
      state.userPaused = !video.paused;
      if (video.paused) play(video); else video.pause();
    });
    video.addEventListener('playing', () => {
      if (document.hidden || (observer && !state.visible)) { video.pause(); return; }
      shell.setAttribute('data-started','');
      shell.setAttribute('data-playing','');
      button.setAttribute('aria-label',button.dataset.pause);
    });
    video.addEventListener('pause', () => {
      shell.removeAttribute('data-playing');
      button.setAttribute('aria-label',button.dataset.play);
    });
    observer?.observe(shell);
  });
  init(document);
  document.addEventListener('visibilitychange', () => videos.forEach(state => {
    if (document.hidden) state.video.pause();
    else if (state.visible && !state.userPaused && autoAllowed()) play(state.video);
  }));
  motion.addEventListener('change', () => { if (motion.matches) videos.forEach(state => state.video.pause()); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => videos.forEach((state,shell) => {
    if (event.target.contains(shell)) { state.video.pause(); observer?.unobserve(shell); videos.delete(shell); }
  }));
})();
